export default __webpack_public_path__ + "static/media/call-removebg-preview.4417a6e4.png";